<script>
	import { onMount } from 'svelte';
	import { fade, fly, blur, slide } from 'svelte/transition';
	import { circOut } from 'svelte/easing';
	import { viewport, components } from '$lib/stores/shared.svelte.js'
	import Logo from '$lib/images/logo-word.svg';
	import Nav from '$components/nav.svelte';
	import FancyButton from './fancyButton.svelte';
	let height = $state(0);
	let menuOpen = $derived(components.navOpen);
	let scroll = $derived(viewport.scrollY > 60 ? true : false );
	let index = $state(0);
	const scrollTopMessages = [
		'Back to top',
		'Beginning',
		'To the top',
		'Page top',
		'Return',
		'Beam me up',
		'Topside',
		'Energize',
		'Up up and away',
		'Once more',
		'From the start',
	]
	let scrollMessagesCurrent = $derived(scrollTopMessages[index]);

	onMount( () => {
		components.headH = height;
	});

	async function scrollTo(target) {
		if (target === 'top') {
			window.scrollTo({ top: 0, behavior: 'smooth' });
			await waitForScrollTop();	
			index = (index + 1) % scrollTopMessages.length;
				
		} else {
			document.querySelector(target)?.scrollIntoView({ behavior: 'smooth' });
		}
	};

	async function waitForScrollTop() {
		return new Promise((resolve) => {
			const check = () => {
				if (window.scrollY === 0) {
					resolve();
				} else {
					requestAnimationFrame(check);
				}
			};
			check();
		});
	}

</script>
<header
	class={["f-row align-cc", {menuOpen}]}
	bind:offsetHeight={height}
	>
	<div 
		class={["w-100p f-row align-sb align2-c prescroll" , { scroll }]}
		>
	<div class="fixedWidth f align-fs align2-c">
		<Nav />
	</div>

		<a href="/" class="logo f" aria-label="logo" style="height: {viewport.navW}px;">
            <!-- <img class="logo" src="{Logo}" alt="KINETIC" /> -->
			 Kinetic Design
        </a>

	<div class="fixedWidth f align-fe">

{#if viewport.vw > 768 }
	{#if scroll}
		<button
			class="backtoTop"
			onclick={() => scrollTo('top')}
			in:fly={{ duration: 400, x: 200, easing: circOut }}
			out:fly={{ duration: 200, x: 60, easing: circOut }}
		>
			<span style="font-weight: 200; font-size: .875rem; font-family: 'Inter Variable', sans-serif;">↑</span>
				{scrollMessagesCurrent}
			</button>
	{/if}
{/if}
	</div>
	<!-- <FancyButton 
		text="Book a call"
		click={() => goto('/booking')}
	/> -->
	</div>
	{#if viewport.vw < 768}
		<div style="width: {components.navW}px;"></div>
	{/if}

</header>

{#if viewport.vw < 768}
{#if scroll}
<button 
	class="backtoTop"
	onclick={() => scrollTo('top')}
	in:fly={{ duration: 500, y: 100, easing: circOut }}
	out:fly={{ duration: 400, y: -60, easing: circOut }}
	aria-label="Back to Top"
	>
<span>↑</span>
</button>
{/if}
{/if}

<style>	
/* Desktop First */
header, div {
	width: 100%;
}

header {
	z-index: 10;
	height: 12rem;
	position: relative;
	background-color: var(--main-bg-color);
	/* background-color: darkcyan; */
	
}

div {
	z-index: 9;
	transition: all .45s ease;
}

div.prescroll {
	height: 6.5rem;
}

div.scroll {
	z-index: 10;
	position: fixed;
	top: .75rem;
	max-width: 56%;
	height: 6.5rem;
	padding: 0;
	display: flex;
	flex-direction: row;
	justify-content: space-around;
	align-items: center;
	gap: 1rem;
	border-radius: .75rem;
	border-top: 1px solid white;
	background-color: hsla(0, 0%, 5%, 0.8);
	box-shadow: -0.05rem 0.1rem 0.25rem #333;
	-webkit-backdrop-filter: blur(20px);        
	backdrop-filter: blur(20px);
}

.scroll a {
	width: 40%;
}

a {
	width: 100%;
	justify-content: center;
	align-items: center;
	/* padding: var(--space-s-m); */
	color: var(--body-font-color);
}
a.logo {
	font-family: 'Instrument Sans Variable', sans-serif;
	font-weight: 500;
	letter-spacing: -.034rem;
}

img.logo {
	height: var(--step-1);
	transition: all .3s ease;
}

.fixedWidth {
	max-width: 8rem;
}
/* 
.menuOpen {
	position: absolute;
	top: 0;
	left: 0;
	max-width: 100vw;
	max-height: 100vh;
} */

header.menuOpen {
	position: fixed;
	height: 100vh; /* Full screen effect */
}

.menuOpen div.scroll  {
	position: fixed;
	top: 0;
	max-width: 100%;
	height: 100%;
	border: none;
	border-radius: 0;
	box-shadow: none;
	/* background-color: black; */
}

.menuOpen div.prescroll {
	width: 100%;
	height: 100%;
}

.menuOpen .fixedWidth, .menuOpen a {
	position: fixed; /** relative will give accurage pos*/
	top: 4.25rem; /* Don't mess with this or the nav icon will shift when animating */
	left: var(--main-pad); /* Fixed */
}

.menuOpen div.scroll .fixedWidth {
	/* left: 4rem; */
}

/* .menuOpen a {
	pointer-events: none;
} */

.menuOpen a,
.menuOpen button.backtoTop {
	display: none;
}

button.backtoTop {
	z-index: 9;
	cursor: pointer;
	/* top: .25rem; */
	/* right: clamp(3.5rem, -39.75rem + 43.125vw, 24rem); */
	/* min-height: 2.5rem; */
	padding: .25rem .5rem;
	background-color: transparent;
	color: white;
	white-space: nowrap;
	font-size: var(--step--1);
	font-family: 'Inter Variable', sans-serif;
	font-weight: 200;
}

/* Mobile Breakpoint */

@media (max-width: 768px) {
	
	header, a, img, img.logo {
		width: 100%;
		padding: 0;
		margin: 0;
	}


	header {
		height: 6.5rem;	
		padding: var(--main-pad-mobile);
		padding-top: 2rem;
	}

	header.menuOpen {
		padding: 0;
	}

	.fixedWidth {
		width: auto;
	}

	header.scroll {
		z-index: 9;
		position: fixed;
		background-color: hsla(0, 0%, 9%, 0.7);
		box-shadow: -0.05rem 0.1rem 0.25rem #333;
		-webkit-backdrop-filter: blur(8px);        
		backdrop-filter: blur(8px);
	}

	.menuOpen .fixedWidth, .menuOpen a {
		position: fixed; /** relative will give accurage pos*/
		top: 1.75rem; /* Don't mess with this or the nav icon will shift when animating */
		left: var(--main-pad-mobile); 
	}

	div.scroll {
		top: 0;
		max-width: 100%;
		padding: 0;
		border-radius: 0;
		border-top: none;
	}
/* 
	header.scroll .spacer {
		display: none;
	} */

	header.scroll a {
		width: 100%;
		/* padding: var(--d12) var(--d18); */
		padding: 0;
	}

	a {
		width: fit-content;
		/* justify-content: flex-end; */
		/* padding: var(--d12) var(--d18); */
		padding: 0;
	}

	img.logo {
		height: var(--step-5);
		width: fit-content;
		padding: 0;
		margin: 0;
		/* padding: 0; */
	}


	button.backtoTop {
		position: fixed;
		left: 5vw;
		bottom: 6.875rem;
		width: 6rem;
		height: 6rem; 
		padding: .5rem;
		font-size: 2rem;
		font-weight: 400;
		border-radius: 4rem;
		border-top: 1px solid white;
		box-shadow: -0.05rem 0.1rem 0.25rem #333;
		background-color: hsla(0, 0%, 6%, 0.7);
		-webkit-backdrop-filter: blur(6px);        
		backdrop-filter: blur(6px);
	}

	button.backtoTop span {
		
		font-family: 'Inter Variable', sans-serif;
		font-weight: 200;
	}
}

</style>

<!-- {#if scrollY > 0}
	<style>
		header {
			z-index: 10;
			position: fixed;
			top: 0;
			right: 0;
			background-color: hsla(0, 0%, 11%, .65);
		}
	</style>
{/if} -->